import { render, staticRenderFns } from "./ConsentFormMS.vue?vue&type=template&id=11873356"
import script from "./ConsentFormMS.vue?vue&type=script&lang=js"
export * from "./ConsentFormMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports